/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @interface WriteableQueryResultAPI
 * @hideconstructor
 * @classdesc API class that is used to mutate a query result object.
 * @example queryResults.getResult()
 */
define([], () => {
	class WriteableQueryResultAPI {

		// TODO: Move from QueryResultAPI
		// /**
		//  * @function QueryResultAPI#setPropertyValue
		//  * @description Set a property value.
		//  * @private
		//  *
		//  * @param {String} name Property name
		//  * @param {String} value Property value
		//  */
		// setPropertyValue() {}

		// TODO: Move from QueryResultAPI
		// /**
		//  * @public
		//  * @function QueryResultAPI#setPointDecorations
		//  * @description Set decorations for a datapoint
		//  * @param {Number} rowIndex Numeric row index of the value
		//  * @param {Object} Object map containing decorations in name/value pairs.
		//  */
		// setPointDecorations() {}

		/**
		 * @public
		 * @function WriteableQueryResultAPI#sortResultItems
		 * @description Reorder items in each result item with the corresponding `compare` function
		 *              (omit to not change order). Row data should be reordered to agree with
		 *              result item order, if applicable.
		 * @param {function[]} compare
		 */
		sortResultItems() {}

		/**
		 * @public
		 * @function WriteableQueryResultAPI#deleteDataItems
		 * @description delete data items and values in the indices,
		 * @param {int[]} indexList data items to remove
		 */
		deleteDataItems() {}

	}

	return WriteableQueryResultAPI;
});
